import { del, get, set } from "idb-keyval";

const key = (groupId: number, day: number) => `video-${groupId}-${day}`;

export function saveVideo(groupId: number, day: number, file: Blob): Promise<void> {
  return set(key(groupId, day), file);
}

export function loadVideo(groupId: number, day: number): Promise<Blob | undefined> {
  return get<Blob>(key(groupId, day));
}

export function deleteVideo(groupId: number, day: number): Promise<void> {
  return del(key(groupId, day));
}
